import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Context from "../contexts/data";
import { getLenderByBuyer } from "../util/lenders";
import Result from "./Result";

const TestResult = () => {
  const { handleUpdateFormValue } = useContext(Context);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const mockBuyer = searchParams.get("mock_buyer");
    if (mockBuyer) {
      handleUpdateFormValue("matchedLender", getLenderByBuyer(mockBuyer));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Result />;
};

export default TestResult;
